import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import moment from 'moment'
Vue.prototype.moment = moment;

import { userHasClearance } from "@/utils/helpers";
import VueLazyload from 'vue-lazyload';

// const loadimage = require('@/assets/media/images/product/product-placeholder.jpg')

Vue.use(VueLazyload)

Vue.mixin({
  methods: {
    userHasClearance,
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
